import React from 'react'
import { Separator } from '@fs/zion-ui'
import { NoticeLoading } from '@fs/zion-icon'

export default function LargeLoadingSpinner() {
  return (
    <div style={{ textAlign: 'center' }}>
      <Separator size="lg" />
      <NoticeLoading size="lg" />
    </div>
  )
}
